module.exports = __webpack_public_path__ + "static/media/io.aecf8a97.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/io.svg
// module id = 1066
// module chunks = 0